import { render, staticRenderFns } from "./editCheckbox.vue?vue&type=template&id=9956b122&scoped=true"
import script from "./editCheckbox.vue?vue&type=script&lang=js"
export * from "./editCheckbox.vue?vue&type=script&lang=js"
import style0 from "./editCheckbox.vue?vue&type=style&index=0&id=9956b122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9956b122",
  null
  
)

export default component.exports